import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import NextSubsectionPanelView from './NextSubsectionPanel.view';

const NextSubsectionPanel = ({ t, tReady, i18nOptions, ...restProps }) => {
  return <NextSubsectionPanelView title={t('NEXT_SUBSECTION_PANEL.TITLE')} {...restProps} />;
};

export default withTranslation('classroom')(NextSubsectionPanel);
